// /***********************************************************************
//  *                           Array扩展工具类                           *
//  * ********************************************************************/
/*两个数组差别*/
Array.getArrDifference = function(array1, array2) {
  let res1 = [] //新增的
  let res2 = [] //删除的
  for (let i in array1) {
    let v = true
    for (let j in array2) {
      if (array1[i] == array2[j]) {
        v = false
      }
    }
    if (v) {
      res2.push(array1[i])
    }
  }
  for (let i in array2) {
    let v = true
    for (let j in array1) {
      if (array2[i] == array1[j]) {
        v = false
      }
    }
    if (v) {
      res1.push(array2[i])
    }
  }
  return [res1, res2]
}
/*两个数组差别*/
export function getArrDifference(array1, array2) {
  let res1 = [] //新增的
  let res2 = [] //删除的
  for (let i in array1) {
    let v = true
    for (let j in array2) {
      if (array1[i] == array2[j]) {
        v = false
      }
    }
    if (v) {
      res2.push(array1[i])
    }
  }
  for (let i in array2) {
    let v = true
    for (let j in array1) {
      if (array2[i] == array1[j]) {
        v = false
      }
    }
    if (v) {
      res1.push(array2[i])
    }
  }
  return [res1, res2]
}

// /**
//  * 遍历
//  * @param {arr} 数组
//  * @param {fn} 回调函数
//  * @return {undefined}
//  */
Array.each = function(arr, fn) {
  fn = fn || Function
  var a = []
  var args = Array.prototype.slice.call(arguments, 1)
  for (var i = 0; i < arr.length; i++) {
    var res = fn.apply(arr, [arr[i], i].concat(args))
    if (res != null) a.push(res)
  }
}

/*去重*/
Array.unique = function(arr) {
  if (Array.hasOwnProperty('from')) {
    return Array.from(new Set(arr))
  } else {
    var n = {},
      r = []
    for (var i = 0; i < arr.length; i++) {
      if (!n[arr[i]]) {
        n[arr[i]] = true
        r.push(arr[i])
      }
    }
    return r
  }
}

/*求两个集合的并集*/
Array.union = function(a, b) {
  return a.concat(b).unique()
}

/*两个数组的交集*/

Array.intersect = function(a, b) {
  var sb = new Set(b)
  return Array.unique(a.filter(x => sb.has(x)))
}
/*两个数组的差集*/
Array.minus = function(a, b) {
  var sb = new Set(b)
  return a.filter(x => !sb.has(x))
}
/*两个数组的补集*/
Array.complement = function(a, b) {
  return Array.minus(Array.union(a, b), Array.intersect(a, b))
}

/*删除其中一个元素*/
Array.remove = function(arr, e) {
  var index = arr.indexOf(e)
  if (index > -1) {
    arr.splice(index, 1)
  }
  return arr
}

/*最大值*/
Array.max = function(arr) {
  return Math.max.apply(null, arr)
}

/*最小值*/
Array.min = function(arr) {
  return Math.min.apply(null, arr)
}

/*求和*/
Array.sum = function(arr) {
  return arr.reduce((pre, cur) => {
    return pre + cur
  })
}

/*平均值*/
Array.avg = function(arr) {
  return Array.sum(arr) / arr.length
}



// WEBPACK FOOTER //
// ./src/utils/array.js